import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props { fullPage?: boolean }

export default function LoadingSpinner({ fullPage }: Props) {
  if (fullPage) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress />
    </Box>
  )
}
